import { useState } from 'react';
import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { DateTimePicker, defaultDateTimeLocalValue } from '@/components/ui/DateTimePicker';

type Props = {
  open: boolean;
  campaignName: string;
  onClose: () => void;
  onConfirm: (scheduledAt: string) => Promise<void>;
};

export function ScheduleCampaignModal({ open, campaignName, onClose, onConfirm }: Props) {
  const [value, setValue] = useState(defaultDateTimeLocalValue);
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    try {
      const iso = new Date(value).toISOString().slice(0, 19);
      await onConfirm(iso);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Schedule campaign"
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button loading={loading} onClick={() => void submit()}>
            Schedule
          </Button>
        </>
      }
    >
      <p className="text-sm text-slate-600 mb-4">
        Set send time for <span className="font-medium text-slate-800 dark:text-slate-100">{campaignName}</span>.
      </p>
      <DateTimePicker label="Send at" value={value} onChange={setValue} />
    </Modal>
  );
}
